// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const unpinReportPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  report_id: z.number().int().describe("Report ID to unpin"),
});

export const unpinReportHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Report unpinned successfully
 */
export const unpinReport200Schema = z.object({});

/**
 * @description Pinned report not found
 */
export const unpinReport404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const unpinReportMutationResponseSchema = z.lazy(() => unpinReport200Schema);
